// @flow
import React, { Component } from "react";
import classNames from "classnames";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DownIcon from "@material-ui/icons/KeyboardArrowDown";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  speedDial: {
    position: "absolute",
    alignItems: "center",
    top: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  rootMargin: {
    top: "2px !IMPORTANT",
    right: "2px !IMPORTANT"
  },
  speedButton: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    border: "1px solid " + theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.third,
      color: theme.palette.common.white
    }
  },
  fab: {
    opacity: "0.5",
    "&:hover": {
      opacity: "1"
    }
  },
  smallFab: {
    width: "40px",
    height: "40px"
  }
});

type SpeedDialActionType = {
  icon: React$Element<*>,
  name: string,
  onclick: Function
};

type StyledSpeedDialClassesType = {
  speedDial: DictionaryType,
  rootMargin: DictionaryType,
  speedButton: DictionaryType,
  fab: DictionaryType,
  smallFab: DictionaryType
};

type StyledSpeedDialPropsType = {
  classes: StyledSpeedDialClassesType,
  actions: Array<SpeedDialActionType>,
  hidden?: boolean,
  isSmall?: boolean,
  isNoMargin?: boolean,
  isClickOnly?: boolean
};

type StyledSpeedDialStatesType = {
  open: boolean
};

class StyledSpeedDial extends Component<
  StyledSpeedDialPropsType,
  StyledSpeedDialStatesType
> {
  constructor(props: StyledSpeedDialPropsType) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClick = (): * => {
    this.setState({
      open: !this.state.open
    });
  };

  handleOpen = (): * => {
    if (this.props.hidden !== true) {
      this.setState({
        open: true
      });
    }
  };

  handleClose = (): * => {
    this.setState({
      open: false
    });
  };

  buttonClick = (action: Function): * => (): * => {
    this.setState(
      {
        open: false
      },
      action()
    );
  };

  render(): * {
    const classes = this.props.classes;

    return (
      <ClickAwayListener onClickAway={this.handleClose}>
        <SpeedDial
          ariaLabel="Styled SpeedDial"
          classes={{
            root: classNames(
              classes.speedDial,
              this.props.isNoMargin && classes.rootMargin
            ),
            fab: classNames(classes.fab, this.props.isSmall && classes.smallFab)
          }}
          hidden={this.props.hidden}
          icon={<SpeedDialIcon icon={<DownIcon />} openIcon={<CloseIcon />} />}
          onClick={this.handleClick}
          onClose={this.handleClose}
          {...(!this.props.isClickOnly ? { onBlur: this.handleClose } : {})}
          {...(!this.props.isClickOnly ? { onFocus: this.handleOpen } : {})}
          {...(!this.props.isClickOnly
            ? { onMouseEnter: this.handleOpen }
            : {})}
          {...(!this.props.isClickOnly
            ? { onMouseLeave: this.handleClose }
            : {})}
          open={this.state.open}
          direction="down"
        >
          {this.props.actions &&
            this.props.actions.map((action: SpeedDialActionType): * => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                tooltipOpen
                onClick={this.buttonClick(action.onclick)}
                classes={{
                  button: classes.speedButton
                }}
              />
            ))}
        </SpeedDial>
      </ClickAwayListener>
    );
  }
}

export default withStyles(styles)(StyledSpeedDial);
